<template>
    <div>
        <div class="flex clearfix">
            <div class="pay">
                <tabs :preClick="tabPreClick" v-model='tabType'>
                    <tabsPane label='续费' keyword="renew">
                        <Renew ref='renewbuy' v-show='tabType == "renew"' />
                        <!-- <AddBuy ref='addbuy' v-show='tabType == "renew"' :data='addBuyData' /> -->
                    </tabsPane>
                    <tabsPane label='加购（新购）' keyword="add">
                        <AddBuy ref='addbuy' v-show='tabType == "add"' :data='addBuyData' />
                    </tabsPane>
                </tabs>
                <div class="price_ctrl_wrapper"
                    v-show="((tabType == 'renew') || (tabType == 'add'))"
                    :style="{paddingTop: '15px'}">
                    <div class="price" v-show="quant*annexation > 0" v-html='mainPrice'></div>
                    <div class="control">
                        <NormalButton class="buy" :disabled='buyBtnDisable' :theme='"red"' ref='buy'
                            @click='buynow'>立即购买</NormalButton>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tabs from "@/components/tabs"
    import tabsPane from '@/components/tabsPane'
    import NewBuy from './NewBuy'
    import AddBuy from './AddBuy'
    import Renew from './Renew'
    import config from '@/assets/js/config.js'
    import cookie from 'js-cookie'
    import wh from '@/assets/js/wh.js'
    export default {
        name: 'Productpay',
        provide() {
            let self = this
            return {
                renewValidCross(x) {
                    self.renewValidCross = x
                    self.$store.commit('renewbuy/setCrossFlag', x)
                },
                addValidCross(x) {
                    self.addValidCross = x
                    self.$store.commit('addbuy/setCrossFlag', x)
                },
                changeAuthPrice(x) {
                    //修改附加项价格的时候，把附加项价格提交到对应的vuex模块（新购，加购，续费）
                    self.annexation = x
                    if (self.tabType == 'add') {
                        self.$store.commit('addbuy/setPrice', x)
                    } else if (self.tabType == 'renew') {
                        self.$store.commit('renewbuy/setPrice', x)
                    }
                },
                changeMainPrice(x) {
                    //目前只有续费会修改主价格
                    self.changeMainPrice(x)
                },
                currentPage() {
                    return self.tabType
                },
                buy() {
                    setTimeout(_ => {
                        self.$refs.buy.click()
                    })
                },
                globalTabType() {
                    return self.tabType
                },
                setMultipleAccounts (x) {
                    self.multipleAccounts = x
                    self.quant = x.length > 0 ? x.length : 1
                    self.$store.commit('renewbuy/setAccounts',x)
                },
                orderByMonth (price) {
                    self.orderLimit = 0
                    self.changeMainPrice(price || self.monthprice)
                    self.canOrderByMonth = true
                },
                orderByQuarter (price) {
                    self.orderLimit = 2
                    self.changeMainPrice(price || self.quarterprice)
                    self.canOrderByQuarter = true
                },
                orderByYear (price) {
                    self.orderLimit = 1
                    self.changeMainPrice(price || self.dataPrice)
                },
                orderByCancel () {
                    self.orderLimit = 1
                    if(self.productData.monthprice && self.productData.monthprice != self.productData.price) {
                        self.canOrderByMonth = true
                    } else {
                        self.canOrderByMonth = false
                    }
                    if(self.productData.quarterprice && self.productData.quarterprice != self.productData.price) {
                        self.canOrderByQuarter = true
                    } else {
                        self.canOrderByQuarter = false
                    }
                },
                getPwdAddress() {
                    return self.data.pwdAddress
                },
                setHistoryIsPoping (val) {
                    self.historyIsPoping = val
                },
                phone(){
                    return self.phone
                },
                oldright(){
                    return {
                        data:self.oldright,
                        stime: self.wh5order.stime,
                        etime: self.wh5order.etime
                    }
                },
                freshPriceData (identityType,isQuarter_sub = false) {
                    self.setLoading(true)
                    self.$axios({
                        url: "/api/Wh5Order/Wh5AccountAdd?pid=129&account=" + self.$route.params.account + "&identityType=" + identityType + '&isQuarter_sub=' + isQuarter_sub,
                        method: "get",
                        useCache: false
                    })
                    .then((res,isCache) => {
                        if (res.data.status) {
                            if (self.tabType == 'add') {
                                res.data.data.sublist && res.data.data.sublist.forEach(self.$refs.addbuy.setPriceByItem)
                                self.wh5order.userCode = res.data.userCode
                            } else {
                                res.data.result.sublist.forEach(self.$refs.renewbuy.setPriceByItem)
                                self.wh5order.userCode = res.data.usercode
                            }

                        } else {
                            self.$market.alert({content: res.data.message})
                        }
                        self.setLoading(false)
                        
                    }).catch(e=>{
                        self.$market.alert({content: '服务器错误，请稍后再试。'})
                    })
                },
                tabToAdd () {
                    self.tabType = 'add'
                }
            }
        },
        inject: ['setLoading'],
        components: {
            tabs,
            tabsPane,
            NewBuy,
            AddBuy,
            Renew,
        },
        model: {
            prop: 'data',
            event: 'change'
        },
        mounted() {
            this.Wh5AccountAdd()
        },
        methods: {
            tabPreClick (item) {
                let i = item.keyword == "renew" ? 1 : 3
                if (item.keyword == "renew") {
                    this.Wh5AccountRenew()
                } else {
                    this.Wh5AccountAdd()
                }
                return false
            },
            picEnter(index) {
                this.picIndex = index
            },
            setBuyData(val) {
                //加购部分所需的数据配置
                this.addBuyData = val.configure.map(v => ({
                    name: v.productName,
                    price: v.price,
                    monthprice: v.monthprice,
                    id: v.id,
                    link: v.link,
                    disable: true,
                    bought: false,
                    isTaoli: v.isTaoli
                }))
                let addInnerAuth = val.authorization.filter(v => v.isout == 0 && v.grouptype != 7 && v.grouptype != 8).map(v => ({
                    ...v,
                    cdisable: false
                }))
                let addOuterAuth = val.authorization.filter(v => v.isout == 1 && v.grouptype != 7 && v.grouptype != 8).map(v => ({
                    ...v,
                    cdisable: false
                }))
                let addHistoryData = val.authorization.filter(v => v.grouptype == 7 || v.grouptype == 8).map(v => ({
                    ...v,
                    cdisable: false
                }))
                let add_require = []
                if (addInnerAuth.length>0) {
                    add_require.push({
                        id:wh.randomId(),
                        name: '国内五档数据等',
                        sublist: addInnerAuth, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: true,
                        bought: false
                    })
                }
                if (addOuterAuth.length > 0) {
                    add_require.push({
                        id:wh.randomId(),
                        name: '境外实时数据',
                        sublist: addOuterAuth, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: false,
                        bought: false
                    })
                }
                if (addHistoryData.length > 0) {
                    add_require.push({
                        id:wh.randomId(),
                        name: '历史数据API',
                        link: 'https://www.wenhua.com.cn/guide/lssj.htm',
                        sublist: historyData, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: true,
                        bought: false
                    })
                }

                if (this.addBuyData.length > 2) {
                    this.addBuyData = [...add_require,{type: 'line'},...this.addBuyData]
                } else {
                    this.addBuyData = [...this.addBuyData, ...add_require]
                }
            },
            async buynow(finish,load) {
                // this.$market.alert({
                //     content: '暂时无法购买，敬请期待。'
                // })
                // return
                let self = this
                //柏慧要求，弹窗的时候按钮不loading
                finish && finish()

                if (!(this.quant * this.annexation)) {
                    finish()
                    this.$market.alert({
                        content: '请选择要购买的授权。'
                    })
                    return
                }
                //因为之前有弹窗，所以此处重新loading效果
                load()
                if (this.tabType == 'add') {
                    console.log( this.$store)
                    var url = '/api/Wh5Order/CMEIndex'
                    var ismajor = this.$refs.addbuy.hasMajor
                    var isjg = this.$refs.addbuy.hasOgz
                    var ids = this.$refs.addbuy.selectIds
                    var data = {
                        productId: 129, // 加购的产品号从接口中取，原parseInt(this.$route.params.id),
                        isDanAuthorization: false,
                        identityType: 3,
                        dzh: this.wh5order.dzh,
                        xzh: this.wh5order.xzh,
                        subids: ids,
                        buynum: parseInt(this.quant),
                        userCode: this.wh5order.userCode,
                        ismajor: ismajor,
                        isjg: isjg,
                        userSdate: this.wh5order.stime,
                        userEdate: this.wh5order.etime,
                        morderid: '',
                        phone: this.phone,
                        isQuarterPay_sub: this.$store.state.addbuy.is_quarter
                    }
                    this.$store.commit('addbuy/setInterface', {
                        url,
                        data
                    })
                    this.$axios({
                        url: url,
                        method: "post",
                        data: data,
                    })
                    .then(res => {
                        finish()
                        if (!res.data.status) {
                            return self.$market.alert({
                                content: res.data.message
                            })
                        }
                        res.data.hasHistory = this.$refs.addbuy.hasHistoryData
                        if (res.data.hasHistory) {
                            res.data.isCme = true
                        }
                        self.$store.commit('setOrderInfo', res)
                        self.$emit('buy')
                    }).catch(e => {
                        finish()
                    })
                } else if (this.tabType == 'renew') {
                    var url = '/api/Wh5Order/CMEIndex'
                    var ids = this.$refs.renewbuy.selectIds
                    var data = {
                        productId: 129, // 加购的产品号从接口中取，原parseInt(this.$route.params.id),
                        isDanAuthorization: false,
                        identityType: 1,
                        dzh: this.wh5order.dzh,
                        xzh: this.wh5order.xzh,
                        subids: ids,
                        buynum: parseInt(this.quant),
                        userCode: this.wh5order.userCode,
                        ismajor: this.$store.state.renewbuy.fetchInfo.ismajor,
                        isjg: this.$store.state.renewbuy.fetchInfo.isjg,
                        userSdate: this.wh5order.stime,
                        userEdate: this.wh5order.etime,
                        morderid: '',
                        phone: this.phone,
                        isQuarterPay_sub: this.$store.state.renewbuy.is_quarter
                    }
                    this.$store.commit('renewbuy/setInterface', {
                        url,
                        data
                    })
                    this.$axios({
                        url: url,
                        method: "post",
                        data: data,
                    })
                    .then(res => {
                        finish()
                        if (!res.data.status) {
                            return self.$market.alert({
                                content: res.data.message
                            })
                        }
                        res.data.hasHistory = this.$refs.addbuy.hasHistoryData
                        if (res.data.hasHistory) {
                            res.data.isCme = true
                        }
                        self.$store.commit('setOrderInfo', res)
                        self.$emit('buy')
                    }).catch(e => {
                        finish()
                    })
                }
            },
            changeMainPrice(x) {
                //目前只有续费会修改主价格
                if (this.tabType == 'renew') {
                    this.price = x
                    this.$store.commit('renewbuy/setMainPrice', x)
                } else if (this.tabType == 'add') {
                    this.price = x
                    this.$store.commit('addbuy/setMainPrice', x)
                } else {
                    this.price = x
                }
            },
            initData (res) {
                let self = this
                self.ppData.name = res.data.productName
                self.ppData.stock = res.data.stock
                self.ppData.notice = res.data.productNote.split('；').filter(v=>v !='')
                self.ppData.price = res.data.price
                self.ppData.monthprice = res.data.monthprice
                self.ppData.configure = res.data.sublist ? res.data.sublist.filter(v=>v.grouptype == -1) : []
                self.ppData.authorization = res.data.sublist ? res.data.sublist.filter(v=>v.grouptype != -1) : []
                self.ppData.wenhuaProduct = res.data.wenHuaProduct ? res.data.wenHuaProduct : []
                self.ppData.pic = res.data.pImgUrlList ? res.data.pImgUrlList : [] 
                self.ppData.limited = res.data.limited
                self.ppData.unit = res.data.unit
                self.ppData.isWht = res.data.isWht
                this.ppData.pwdAddress = res.data.pwdAddress
                self.phone = res.phone
                self.oldright = res.oldright
                self.wh5order.dzh = res.dzh
                self.wh5order.xzh = res.xzh
                self.wh5order.stime = res.stime
                self.wh5order.etime = res.etime
                self.wh5order.userCode = res.userCode

                this.$store.commit('setPic', res.data.pImgUrlList ? res.data.pImgUrlList : [])
                this.$store.commit('setProductAddress', res.data.productAddress ? res.data.productAddress : "")

                this.setBuyData(self.ppData)

            },
            initRenewData (res) {},
            Wh5AccountAdd(){
                var self = this

                this.setLoading(true)
                this.historyIsPoping = true
                //获取产品的详情数据
                this.$axios({
                    url: "/api/Wh5Order/Wh5AccountAdd?pid=129&account=" + this.$route.params.account + "&identityType=3",
                    method: "get",
                    useCache: true
                })
                .then((res,isCache) => {
                    self.historyIsPoping = !res.data.status
                    if (res.data.status) {
                        self.initData(res.data)
                    } else {
                        this.phone = res.data.phone
                        if (res.data.code == '203') {
                            this.tabType = 'renew'
                            this.Wh5AccountRenew()
                        } else {
                            this.$market.alert({content: res.data.message})
                        }
                    }
                    self.setLoading(false)
                    
                }).catch(e=>{
                    this.$market.alert({content: '服务器错误，请稍后再试。'})
                })
            },
            Wh5AccountRenew(){
                var self = this

                this.setLoading(true)
                //获取产品的详情数据
                this.$axios({
                    url: "/api/Wh5Order/Wh5AccountAdd?pid=129&account=" + this.$route.params.account + "&identityType=1",
                    method: "get",
                })
                .then((res,isCache) => {
                    self.$refs.renewbuy.init(res)
                    if (!res.data.status) {
                        self.$market.alert({content: res.data.message})
                    } else {
                        
                        self.wh5order.dzh = res.data.user.dzh
                        self.wh5order.xzh = res.data.user.xzh
                        self.wh5order.stime = res.data.user.start_date
                        self.wh5order.etime = res.data.user.end_date
                        self.wh5order.userCode = res.data.usercode
                    }
                    self.setLoading(false)
                    
                }).catch(e=>{
                    this.$market.alert({content: '服务器错误，请稍后再试。'})
                })
            }
        },
        data: () => ({
            tabType: 'add',
            tabIndex: 0,
            picList: [],
            picIndex: 0,
            quant: 1,
            price: 0,
            monthprice: 0,
            dataPrice: 0,
            annexation: 0,
            addBuyData: [],
            renewValidCross: false, //是否通过续费验证
            addValidCross: false, //是否通过加购验证
            inputWidth: '',
            multipleAccounts: [],
            peixunke: {
                46:'麦语言',
                107: '麦语言'
            },
            orderLimit: 1, //-1 - 没选， 0 - 选按月， 1 - 选按年
            historyIsPoping: false,
            identityType: 3,
            phone: "",
            oldright: "",
            ppData: {
                pic: [],//[require('../../assets/image/p_1.gif'),require('../../assets/image/p_2.gif'),require('../../assets/image/p_3.gif')],
                name: '',//'文华云主机（赠一个极速行情）',
                price: 0,//1200,
                annexationPrice: 0,
                classify: [],
                notice: [
                    // '购买该权限可下载<a href="http://cxh.wenhua.com.cn/service.asp?pid=2" target="_blank">文文通</a>获得在线即时服务；',
                    // '期货运行模组支持128个，股票运行模组支持256个。'
                ],
                configure: [],
                authorization: [],
                stock: 0,
                unit: '',
                pwdAddress: ''
            },
            wh5order: {
                dzh: '',
                xzh: '',
                stime: '',
                etime: '',
                userCode: '',
            },
            productData: null
        }),
        computed: {
            mainPic() {
                return this.picList[this.picIndex]
            },
            mainPrice() {
                var quant = this.quant,
                    price = this.price,
                    annexation = this.annexation
                var quarter = this.tabType == 'add' ? this.$store.state.addbuy.is_quarter :this.$store.state.renewbuy.is_quarter  //季度true 年false
                console.log(quarter)
                var letterBuy = quarter ? '季' : '年'
                
                if (!annexation) {
                    return `<span class="m">￥</span><span class="num">${quant*price}</span>&nbsp;元`
                }
                if (this.tabType == 'add') {
                    return `<span class="m">￥</span><span class="num">${quant * annexation}</span>&nbsp;元/账号${this.oldright != '' ? '':`/${letterBuy}`}`
                } else {
                    return `<span class="m">￥</span><span class="num">${quant * annexation}</span>&nbsp;元/账号/${letterBuy}`
                }
            },
            buyBtnDisable() {
                return this.$route.name == "Preview" // || (this.$route.params.id == 127 && Number(this.data.stock) <= 0) ?  true : false
            },
            isclient () {
                return this.$store.state.isclient
            },
        },
        watch: {
            
            tabType: {
                handler(val) {
                    //切换新购加购续费时，从vuex上获取之前存储的，附加项价格和数量，并显示
                    if (val == 'add') {
                    } else if (val == 'renew') {
                        
                    }
                    this.$store.commit('setGlobalTabType', val)
                },
                immediate: true
            },
        }
    }
</script>

<style scoped>
.taili_tips {
    line-height: 34px;
    margin-left: 10px;
    color: #444;
    font-size: 13px;
}
    .buynum {
        width: auto;
        padding: 0 5px;
        height: 27px;
        line-height: 26px;
        vertical-align: middle;
        text-align: center;
        outline: 0;
        float: left;
        border: 0;
        color: rgb(133, 133, 133);
        font-size: 14px;
    }

    .flex {
        display: flex;

    }

    .pay {
        /* padding-left: 30px; */
        /* flex: 1; */
        width: 100%;
        float: left;
        box-sizing: border-box;
    }

    .pay .name {
        font-size: 16px;
        color: #3c3c3c;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .pay .price_ctrl_wrapper {
        overflow: hidden;
        background: rgb(247, 248, 250);
        padding-right: 10px;
        padding-bottom: 10px;
    }

    .pay .price {
        /* height: 30px; */
        color: rgb(135, 135, 135);
        font-size: 14px;
        padding-left: 8px;
        box-sizing: border-box;
        float: left;
    }

    .pay .stock {
        height: 30px;
        color: rgb(135, 135, 135);
        font-size: 14px;
        padding-left: 18px;
        box-sizing: border-box;
        line-height: 35px;
        font-weight: normal;
    }

    .pay .control {
        height: 30px;
        font-size: 12px;
        float: right;
    }

    .pay .control .num {
        width: 8px;
        padding: 0 5px;
        height: 27px;
        line-height: 24px;
        background: #fff;
        vertical-align: middle;
        text-align: center;
        outline: 0;
        float: left;
        border: 0;
        color: rgb(133, 133, 133);
    }

    .pay .control .num:disabled {
        background: transparent;
    }

    .arrow {
        display: inline-block;
        vertical-align: middle;
        height: 27px;
        overflow: hidden;
        border: 1px solid rgb(207, 211, 213);
        background: white;
    }

    .arrow.disabled {

        border: 1px solid transparent;
        background: transparent;
    }

    .arrow .arrow_up {
        width: 20px;
        line-height: 27px;
        height: 27px;
        cursor: pointer;
        overflow: hidden;
        zoom: 1;
        margin-bottom: 2px;
        float: left;
        text-align: center;
        color: rgb(133, 133, 133);
        font-size: 20px;
    }

    .arrow .arrow_up.hide {
        display: none;
    }

    .arrow .arrow_down {
        width: 20px;
        height: 27px;
        line-height: 27px;
        cursor: pointer;
        overflow: hidden;
        zoom: 1;
        float: left;
        text-align: center;
        font-size: 20px;
        color: rgb(133, 133, 133);
    }

    .arrow .arrow_down.hide {
        display: none;
    }

    .pay .buy {
        width: 78px;
        height: 27px;
        text-align: center;
        background: rgb(230, 0, 0);
        color: white;
        font-size: 14px;
        vertical-align: middle;
        margin-left: 15px;
        display: inline-block;
    }

    .pay .info {
        width: 100%;
        margin: 10px 0 0 0;
        padding: 8px 6px;
        background: rgb(245, 246, 248);
        box-sizing: border-box;
    }

    .pay .info .title {
        color: rgb(117, 117, 117);
        font-size: 14px;
        font-weight: bold;
        background: url(../../../assets/image/tanhao1.png) no-repeat 4px;
        background-size: 14px;
        padding-left: 25px;
        margin-bottom: 5px;
    }

    .pay .info .line {
        position: relative;
        padding: 0 0 0 12px;
        zoom: 1;
        color: #7a7a7a;
    }

    .pay .info .line::before {
        content: '';
        position: absolute;
        left: 5px;
        top: 8px;
        width: 2px;
        height: 2px;
        border-radius: 100%;
        background-color: #7a7a7a;
    }
</style>